// extracted by mini-css-extract-plugin
module.exports = {"page":"efdelta-recall-reception_page__cQDCb"};